import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import type { StudentProgressPreview } from '../../types';

const trendDisplay: Record<string, { icon: string; color: string }> = {
  UP: { icon: '↑', color: 'text-green-600' },
  DOWN: { icon: '↓', color: 'text-red-600' },
  STABLE: { icon: '→', color: 'text-gray-500' },
};

interface StudentProgressCardProps {
  data: StudentProgressPreview;
}

export function StudentProgressCard({ data }: StudentProgressCardProps) {
  const navigate = useNavigate();
  const trend = trendDisplay[data.trend] ?? trendDisplay.STABLE;

  return (
    <Card
      className="cursor-pointer hover:shadow-md transition-shadow"
      onClick={() => navigate(data.detailUrl)}
    >
      <CardHeader className="p-4 pb-2">
        <div className="flex items-center justify-between gap-2">
          <CardTitle className="text-sm truncate">{data.studentName}</CardTitle>
          <div className="flex items-center gap-1">
            <span className="text-sm font-semibold">{data.overallScore}%</span>
            <span className={`text-lg ${trend.color}`}>{trend.icon}</span>
          </div>
        </div>
      </CardHeader>
      <CardContent className="p-4 pt-0">
        <div className="grid grid-cols-2 gap-x-4 gap-y-1 text-sm">
          {Object.entries(data.subjectScores).map(([subject, score]) => (
            <div key={subject} className="flex justify-between">
              <span className="text-muted-foreground">{subject}</span>
              <span className="font-medium">{score}%</span>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
